export enum E_SEW_SEARCH_FIELD_SIZE {
    Default = 'default',
    XS = 'xs',
    L = 'L',
}
